import React, { useMemo } from 'react';
import Footer from '@ajat/design-system/Footer';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';
import useMenuItemVisibility from '../../../../hooks/useMenuItemVisibility';

/* ══════════════════════════════════════════════════════════════════════════
 * CLS-DK — Common Footer
 * Single source of truth for footer configuration across all CLS-DK pages
 * Navigation column mirrors the Header navItems
 * ══════════════════════════════════════════════════════════════════════════ */

// Columns are built per instance so Studieturstrøjer/Vogntrøjer resolve to
// the customer's mapped school shop (or open the selector) like the Header.
const buildColumns = (onMenuItemClick) => [
  {
    title: 'BRUG FOR HJÆLP?',
    links: [
      { label: 'Størrelses guide', href: '/clothing/cls-dk/size-guide' },
      { label: 'FAQ', href: '/clothing/cls-dk/faq' },
      { label: 'Kontakt os', href: '/clothing/cls-dk/contact' },
      // Reklamation hidden — restore together with the claims route + helpConfig entries.
      // { label: 'Reklamation', href: '/clothing/cls-dk/claims' },
      { label: 'Tryk & Broderi', href: '/clothing/cls-dk/tryk-broderi' },
    ],
  },
  {
    title: 'C.L. SEIFERT',
    links: [
      { label: 'Studieturstrøjer', menuKey: 'menu_1', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_1'); } },
      { label: 'Vogntrøjer', menuKey: 'menu_2', href: '#', onClick: (e) => { e.preventDefault(); onMenuItemClick('menu_2'); } },
      { label: 'AI Logo Generator', href: '/clothing/cls-dk/logo-generator' },
      { label: 'Upload din tegning', href: '/clothing/cls-dk/create-school' },
    ],
  },
];

const legalLinks = [
  { label: 'Köpvillkor', href: '/clothing/cls-dk/terms' },
  { label: 'Privatlivspolitik', href: '/clothing/cls-dk/privacy' },
];

const socials = [
  { icon: 'facebook', href: 'https://www.facebook.com/clseifert.dk', ariaLabel: 'Facebook' },
  { icon: 'instagram', href: 'https://www.instagram.com/clseifert_dk/', ariaLabel: 'Instagram' },
];

const contact = {
  title: 'KONTAKT OS',
  email: { label: 'info@clseifert.dk', href: 'mailto:info@clseifert.dk' },
  address: ['Ny Adelgade 8-10,', '1104, København K'],
};

export const copyright = `© ${new Date().getFullYear()} C.L. Seifert A/S, Danmark. Alle rettigheder forbeholdes.`;

const CLSDKFooter = (props) => {
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'clsdk', feSlug: 'cls-dk' });
  // Same visibility rule as the header menu items ("Disable Open Shop"):
  // menuKey-tagged footer links hide when that shop type isn't available.
  const { isVisible } = useMenuItemVisibility('clsdk');
  const columns = useMemo(
    () => buildColumns(onMenuItemClick).map((col) => ({
      ...col,
      links: col.links.filter((l) => !l.menuKey || isVisible(l.menuKey)),
    })),
    [onMenuItemClick, isVisible],
  );

  return (
    <Footer brand="CLS" columns={columns} legalLinks={legalLinks} socials={socials} contact={contact} copyright={copyright} {...props} />
  );
};

export default CLSDKFooter;
